import { BooleanInput } from '@angular/cdk/coercion';
import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { UserImpl } from 'app/models/user';
import { Util } from 'app/models/util';
import { AuthService } from 'app/services/auth.service';
import { EventService } from 'app/services/event.service';
import { Subject, takeUntil } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector       : 'user',
    templateUrl    : './user.component.html',
    styleUrls: ['./user.component.scss'],
   // encapsulation  : ViewEncapsulation.None,
   // changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'user',
    standalone     : true,
    imports        : [
        MatButtonModule, 
        MatMenuModule, 
        NgIf, 
        MatIconModule, 
        NgClass, 
        MatDividerModule,
        MatTooltipModule,
    ],
})
export class UserComponent implements OnInit, OnDestroy
{
    
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    // user = {
    //     "id": "cfaad35d-07a3-4447-a6c3-d8c3d54fd5df",
    //     "name": "John Levesque",
    //     "email": "john@lollylaw.com",
    //     "avatar": "assets/images/avatars/jrl_photo.jpg",
    //     status: "online"
    // };

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    user : UserImpl = null;

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        public util : Util,
        public eventServ : EventService,
        public authService :AuthService,
    )
    {
        this.user = this.util.getUserFromSession();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.eventServ.getGlobalData.subscribe((data)=>{
            if(data.user) 
            {
                this.user = data.user;
                this.util.setUserInSession(this.user)
            }
        })

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void
    {
       
    }

    /**
    * Route to Settings
    */
    goToProfile(): void
    {
        console.log("gotoprofile");
        this.util.navigateToUserDetail(this.user.id);
    }

    /**
     * Route to Settings
    */
    goToSettings(): void
    {
        console.log("gotosettings");
        this._router.navigate(['/pages/settings']);
    }

    /**
     * Sign out
     */
    signOut(): void
    {
         let recentFromSession = this.util.getUserFromSession();
        if (recentFromSession && recentFromSession.id) {
                this.authService
                    .logout()
                    .then((res) => {
                        // logoutAtmosphere();
                        this.util.logout();
                        //this._router.navigate(['/apps/auth/sign-out']);
                    })
                    .catch((err) => {
                        this.util.logout();
                        console.log(err);
                    });
            } else {
                this.util.logout();
                //this._router.navigate(['apps/auth/sign-out']);
        }

    }
}
